import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { handleAddSubscription } from "../../axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { formatDate1 } from "../../utils/utils";

const AddSubscription = () => {
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    subscriptionPlanType: Yup.string().required(
      "Subscription Plan Type is required"
    ),
    subscriptionPlanPeriod: Yup.string().required(
      "Subscription Plan Period is required"
    ),
    subscriptionStartDate: Yup.date().required(
      "Subscription Start Date is required"
    ),
    subscriptionEndDate: Yup.date().required(
      "Subscription End Date is required"
    ),
    orderId: Yup.string().required("Order ID is required"),
    subscriptionAmount: Yup.string().required(
      "Subscription Amount is required"
    ),
    subscriptionCreatedUserId: Yup.string().required(
      "Subscription Created User ID is required"
    ),
  });

  const initialValues = {
    subscriptionPlanType: "",
    subscriptionPlanPeriod: "",
    subscriptionStartDate: "",
    subscriptionEndDate: "",
    orderId: "",
    subscriptionAmount: "",
    subscriptionCreatedUserId: "",
  };

  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  const handleSubmit = async (values, actions) => {
    try {
      setLoading(true);
      const res = await handleAddSubscription(
        values.subscriptionPlanType,
        values.subscriptionPlanPeriod,
        formatDate1(values.subscriptionStartDate),
        formatDate1(values.subscriptionStartDate),
        values.orderId,
        values.subscriptionAmount,
        values.subscriptionCreatedUserId,
        config
      );

      if (res.status === 200) {
        toast.success(res.data.message, {
          position: "top-right",
        });
        navigate("/payments");
      }
      actions.setSubmitting(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div>
        <p className="font-semibold antialiased tracking-normal text-[22px]">
          Add New Subscription
        </p>
      </div>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="mt-10 ring-2 ring-gray-200 p-5 grid grid-cols-1 lg:grid-cols-2 gap-16">
              <div>
                <div className="mt-3">
                  <p>Subscription Plan Type</p>
                  <Field
                    type="text"
                    name="subscriptionPlanType"
                    className={`outline-none ring-2 ring-gray-200 h-12 indent-3 w-full mt-3 rounded-[8px] ${
                      errors.subscriptionPlanType &&
                      touched.subscriptionPlanType
                        ? "border-red-500"
                        : ""
                    }`}
                    placeholder="Subscription Plan Type"
                  />
                  {errors.subscriptionPlanType &&
                    touched.subscriptionPlanType && (
                      <div className="text-red-500">
                        {errors.subscriptionPlanType}
                      </div>
                    )}
                </div>
                <div className="mt-3">
                  <p>Subscription Plan Period</p>
                  <Field
                    type="text"
                    name="subscriptionPlanPeriod"
                    className={`outline-none ring-2 ring-gray-200 h-12 indent-3 w-full mt-3 rounded-[8px] ${
                      errors.subscriptionPlanPeriod &&
                      touched.subscriptionPlanPeriod
                        ? "border-red-500"
                        : ""
                    }`}
                    placeholder="Subscription Plan Period"
                  />
                  {errors.subscriptionPlanPeriod &&
                    touched.subscriptionPlanPeriod && (
                      <div className="text-red-500">
                        {errors.subscriptionPlanPeriod}
                      </div>
                    )}
                </div>
                <div className="mt-3">
                  <p>Subscription Start Date</p>
                  <Field
                    type="date"
                    name="subscriptionStartDate"
                    className={`outline-none ring-2 ring-gray-200 h-12 indent-3 w-full mt-3 rounded-[8px] ${
                      errors.subscriptionStartDate &&
                      touched.subscriptionStartDate
                        ? "border-red-500"
                        : ""
                    }`}
                    placeholder="Subscription Start Date"
                  />
                  {errors.subscriptionStartDate &&
                    touched.subscriptionStartDate && (
                      <div className="text-red-500">
                        {errors.subscriptionStartDate}
                      </div>
                    )}
                </div>
                <div className="mt-3">
                  <p>Subscription End Date</p>
                  <Field
                    type="date"
                    name="subscriptionEndDate"
                    className={`outline-none ring-2 ring-gray-200 h-12 indent-3 w-full mt-3 rounded-[8px] ${
                      errors.subscriptionEndDate && touched.subscriptionEndDate
                        ? "border-red-500"
                        : ""
                    }`}
                    placeholder="Subscription End Date"
                  />
                  {errors.subscriptionEndDate &&
                    touched.subscriptionEndDate && (
                      <div className="text-red-500">
                        {errors.subscriptionEndDate}
                      </div>
                    )}
                </div>
              </div>

              <div>
                <div className="mt-3">
                  <p>Order Id</p>
                  <Field
                    type="text"
                    name="orderId"
                    className={`outline-none ring-2 ring-gray-200 h-12 indent-3 w-full mt-3 rounded-[8px] ${
                      errors.orderId && touched.orderId ? "border-red-500" : ""
                    }`}
                    placeholder="Ex: 12 digit random number"
                  />
                  {errors.orderId && touched.orderId && (
                    <div className="text-red-500">{errors.orderId}</div>
                  )}
                </div>
                <div className="mt-3">
                  <p>Subscription Amount</p>
                  <Field
                    type="text"
                    name="subscriptionAmount"
                    className={`outline-none ring-2 ring-gray-200 h-12 indent-3 w-full mt-3 rounded-[8px] ${
                      errors.subscriptionAmount && touched.subscriptionAmount
                        ? "border-red-500"
                        : ""
                    }`}
                    placeholder="Subscription Amount"
                  />
                  {errors.subscriptionAmount && touched.subscriptionAmount && (
                    <div className="text-red-500">
                      {errors.subscriptionAmount}
                    </div>
                  )}
                </div>
                <div className="mt-3">
                  <p>Subscription Created User Id</p>
                  <Field
                    type="text"
                    name="subscriptionCreatedUserId"
                    className={`outline-none ring-2 ring-gray-200 h-12 indent-3 w-full mt-3 rounded-[8px] ${
                      errors.subscriptionCreatedUserId &&
                      touched.subscriptionCreatedUserId
                        ? "border-red-500"
                        : ""
                    }`}
                    placeholder="Ex: 65c45f4dd32a9ec0e560f45c"
                  />
                  {errors.subscriptionCreatedUserId &&
                    touched.subscriptionCreatedUserId && (
                      <div className="text-red-500">
                        {errors.subscriptionCreatedUserId}
                      </div>
                    )}
                </div>
              </div>
              <div className="mt-0">
                <button
                  type="submit"
                  className="bg-black text-white h-10 w-[160px] rounded-[8px]"
                >
                  {loading ? <p>Updating...</p> : <p>Save Changes</p>}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddSubscription;
